<template>
  <div>
    <!-- Top Bar for Small/Medium Screens -->
    <div class="fixed top-0 left-0 w-full flex items-center justify-between bg-white p-4 shadow z-40 lg:hidden">
      <router-link to="/admin/support" class="flex items-center">
        <img src="../assets/optimaAI.png" alt="OptimaAI Logo" class="h-9 w-9 cursor-pointer" />
        <span class="ml-2 font-semibold text-gray-900">Admin Panel</span>
      </router-link>

      <button @click="showMobileSidebar = true">
        <svg class="h-8 w-8 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>

    <!-- Admin Sidebar (Desktop) -->
    <div class="relative h-screen hidden lg:flex flex-col bg-white border-r w-72" style="z-index: 60;">
      <div class="p-5 flex items-start justify-start border-b">
        <img src="../assets/optimaAI.png" alt="OptimaAI Logo" class="h-8 w-8 flex-shrink-0 mt-0.5" />
        <div class="ml-3 flex flex-col">
          <span class="text-xl font-semibold text-gray-900">OptimaAI Admin</span>
          <span class="text-xs font-bold text-blue-600 uppercase tracking-widest mt-1">Control Center</span>
        </div>
      </div>

      <nav class="mt-8 flex-1 overflow-y-auto px-4">
        <div class="space-y-1">
          <label class="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Reports & Support</label>
          <router-link to="/admin/support" 
            class="flex items-center px-3 py-3 rounded-lg transition-all duration-200 group"
            :class="[$route.path === '/admin/support' ? 'bg-blue-50 text-blue-600 shadow-sm' : 'text-gray-600 hover:bg-gray-50']">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <span class="ml-3 font-medium">Problem Reports</span>
          </router-link>
        </div>

      </nav>

      <div class="p-4 border-t bg-gray-50">
        <button @click="handleLogout"
          class="flex items-center w-full px-4 py-3 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span class="ml-3 font-medium">Logout</span>
        </button>
      </div>
    </div>

    <!-- Mobile Sidebar Overlay -->
    <transition name="fade">
      <div v-if="showMobileSidebar" class="fixed inset-0 z-50 flex lg:hidden">
        <div class="fixed inset-0 bg-black opacity-50" @click="showMobileSidebar = false"></div>
        <div class="relative bg-white w-72 h-full shadow-lg z-50 flex flex-col">
          <div class="p-5 flex items-center justify-between border-b">
            <div class="flex items-center">
              <img src="../assets/optimaAI.png" alt="OptimaAI Logo" class="h-8 w-8" />
              <span class="ml-3 text-xl font-semibold text-gray-900">Admin Panel</span>
            </div>
            <button @click="showMobileSidebar = false">
              <svg class="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <nav class="mt-8 flex-1 px-4">
            <div class="space-y-1">
              <router-link to="/admin/support" @click="showMobileSidebar = false"
                class="flex items-center px-3 py-3 rounded-lg text-gray-600 active:bg-blue-50 active:text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                <span class="ml-3 font-medium">Problem Reports</span>
              </router-link>

            </div>
          </nav>

          <div class="p-4 border-t">
            <button @click="handleLogout"
              class="flex items-center w-full px-4 py-3 text-gray-600">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span class="ml-3 font-medium">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AdminSidebar",
  data() {
    return {
      showMobileSidebar: false
    };
  },
  methods: {
    handleLogout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("creator");
      localStorage.removeItem("data");
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
